import { BreadcrumbSkeleton } from '@/components/ui/breadcrumb-skeleton.component';
import { Card } from '@/components/ui/card.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Skeleton } from '@/components/ui/skeleton.component';
import { EntityAboutLoading } from '@/app/(main)/(pages)/_components/entities/entity-about-loading.component';
import { EntityRatingCardLoading } from '@/app/(main)/(pages)/_components/entities/entity-rating-card-loading.component';

export function PartnerProfileLoading() {
  return (
    <>
      <BreadcrumbSkeleton depth={2} />

      <ContentContainer className="px-0 md:py-6 bg-white md:bg-transparent">
        <div className="block mx-auto sm:max-w-lg md:max-w-full md:w-auto xl:grid xl:grid-cols-2 xl:items-start xl:gap-6">
          <section>
            <Card className="border-0 md:border border-gray-200 md:px-10 pt-6 pb-6 md:pt-8 md:pb-8 3xl:pt-10 3xl:pb-10 w-full">
              <div className="flex flex-col items-center gap-4 pb-6 md:flex-row md:items-start">
                <Skeleton className="h-32 w-32 min-w-32" />

                <div className="flex w-full flex-col items-center gap-2 md:items-start">
                  <Skeleton className="h-8 w-11/12" />
                  <Skeleton className="h-5 w-48" />
                </div>
              </div>

              <Skeleton className="h-20 w-full rounded-xxl" />

              <EntityAboutLoading />

              <EntityRatingCardLoading />
            </Card>
          </section>
        </div>
      </ContentContainer>
    </>
  );
}
